<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Modal from 'dashboard/components/Modal.vue';
import Spinner from 'shared/components/Spinner.vue';
import HistoryRecordItem from './HistoryRecordItem.vue';
import { useMessageEditHistory } from 'dashboard/composables/messages/useMessageEditHistory';

const { t } = useI18n();
const { isOpen, isLoading, history, diffItems, closeModal } =
  useMessageEditHistory();

const sortedDiffItems = computed(() => {
  return [...diffItems.value].sort((a, b) => a.created_at - b.created_at);
});
</script>

<template>
  <Modal :show="isOpen" :on-close="closeModal" class="history-modal">
    <div
      class="flex flex-col h-full bg-white dark:bg-slate-900 w-full max-w-2xl rounded-xl shadow-2xl overflow-hidden"
    >
      <div
        class="flex items-center justify-between px-6 py-4 border-b border-slate-100 dark:border-slate-800"
      >
        <div>
          <h3
            class="text-base font-semibold text-slate-800 dark:text-slate-100"
          >
            {{ t('CONVERSATION.EDIT_HISTORY.TITLE') }}
          </h3>
          <p class="text-xs text-slate-500 mt-0.5">
            {{ t('CONVERSATION.EDIT_HISTORY.SUBTITLE') }}
          </p>
        </div>
      </div>

      <div
        class="flex-1 overflow-y-auto bg-slate-50 dark:bg-slate-900 p-6 min-h-[400px] max-h-[75vh]"
      >
        <div
          v-if="isLoading"
          class="flex flex-col items-center justify-center h-full text-slate-500"
        >
          <Spinner size="md" />
          <span class="mt-3 text-sm">
            {{ t('CONVERSATION.EDIT_HISTORY.LOADING') }}
          </span>
        </div>

        <div
          v-else-if="history.length === 0"
          class="flex flex-col items-center justify-center h-full text-slate-400"
        >
          <i class="i-lucide-history text-4xl mb-4 opacity-50" />
          <p>{{ t('CONVERSATION.EDIT_HISTORY.EMPTY') }}</p>
        </div>

        <div v-else class="space-y-4">
          <HistoryRecordItem
            v-for="item in sortedDiffItems"
            :key="item.id"
            :item="item"
          />

          <div class="flex items-center gap-2 pt-2 opacity-60">
            <i class="i-lucide-arrow-down text-slate-400 size-4" />
            <span class="text-xs text-slate-500 italic">
              {{ t('CONVERSATION.EDIT_HISTORY.CURRENT_BELOW') }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </Modal>
</template>
